import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'tt-time-entry-management',
  templateUrl: './time-entry-management.component.html',
  styleUrls: ['./time-entry-management.component.css']
})
export class TimeEntryManagementComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
